module.exports = __webpack_public_path__ + "static/media/building-onlyupdated.21c219c5.png";